import React, { useEffect } from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import { StudentDashboard } from "./pages/StudentDashboard";
import StudentLogin from "./pages/StudentLogin";
import StudentVerification from "./pages/StudentVerification";
import ForgottenPassword from "./pages/StudentFogottenPassword";
import { StudentSubject } from "./pages/StudentSubject";
import { WorkBook } from "./pages/WorkBook";
import SearchResults from "./pages/SearchResults";
import ProtectedRoute from "./utils/ProtectedRoutes";
import ResetPassword from "./pages/ResetPassword";
import Hotjar from '@hotjar/browser';
import ErrorBoundary from "./utils/ErrorBoundary";
import TagManager from "react-gtm-module";
// import ChatBot from "./components/Chatbot/ChatBot";
import { authCDNCookie, getToken } from "./services/api/login";
import Cookies from "js-cookie";
import useRUMRouteTracker from "./hooks/useRUMRouteTracker";

function App() {
  useRUMRouteTracker();
  const fetchSignedCookies = async () => {
    try {
      const verifyAccess = getToken();
      if(verifyAccess?.token){
      await authCDNCookie(verifyAccess.token).then((res)=>{
        if(res.data?.data){
           console.log(res)
          const isProduction = process.env.NODE_ENV === 'production';
          Object.entries(res.data.data).map(([key,val]:any)=>{
            Cookies.set(key, val, {
                      domain:isProduction?'.contoureducation.com.au':undefined,
                      httpOnly: false,
                      expires: 1 / 144, // 10 minutes
                      secure: isProduction,           // HTTPS-only in production
                      sameSite: isProduction ? 'None' : 'Lax', // Prevent CSRF
                      path: '/',                      // Ensure it's accessible site-wide
                    });

          })
        }
      })
      console.log('Signed cookies received');}
    } catch (error) {
      console.error('Failed to fetch signed cookies', error);
    }
  };
  useEffect(() => {
    fetchSignedCookies();

    const refreshInterval = setInterval(fetchSignedCookies, 4 * 60 * 1000);
    return () => clearInterval(refreshInterval);
  }, []);

  useEffect(() => {
    process.env?.REACT_APP_PUBLIC_URL?.includes("lms.contoureducation.com.au")
      ? TagManager.initialize({ gtmId: process.env.REACT_APP_GTM_ID })
      : console.log('GTM not initialized - Development environment');
  }, []);
  
const siteId = 5264910;
const hotjarVersion = 6;
{process.env?.REACT_APP_PUBLIC_URL?.includes("lms.contoureducation.com.au") && Hotjar.init(siteId, hotjarVersion);}
  return (
    <>
      <Routes>
        <Route path={`/`} element={
          <ErrorBoundary fallback={<div>Something went wrong</div>}>
            <StudentLogin />
          </ErrorBoundary>
          } />
        <Route path={`/verify-login`} element={
          <ErrorBoundary fallback={<div>Something went wrong</div>}>
            <StudentVerification />
          </ErrorBoundary>
          } />
        <Route path={`/forgot-password`} element={
          <ErrorBoundary fallback={<div>Something went wrong</div>}>
            <ForgottenPassword />
          </ErrorBoundary>
          } />
        <Route path={`/reset-password`} element={
          <ErrorBoundary fallback={<div>Something went wrong</div>}>
             <ResetPassword />
          </ErrorBoundary>
         } />
        <Route
          path={`/dashboard`}
          element=
          {
            <ProtectedRoute>
              <ErrorBoundary fallback={<div>Something went wrong</div>}>
                <StudentDashboard />
              </ErrorBoundary>
            </ProtectedRoute>
          }
        />
        <Route
          path={`/subject/:keyword`}
          element=
          {
            <ProtectedRoute>
               <ErrorBoundary fallback={<div>Something went wrong</div>}>
                <StudentSubject />
               </ErrorBoundary>
            </ProtectedRoute>
          }
        />
        <Route
          path={`/aos`}
          element=
          {
            <ProtectedRoute>
               <ErrorBoundary fallback={<div>Something went wrong</div>}>
                <WorkBook />
               </ErrorBoundary>
            </ProtectedRoute>
          }
        />
        <Route
          path={`/search-results`}
          element=
          {
            <ProtectedRoute>
               <ErrorBoundary fallback={<div>Something went wrong</div>}>
                  <SearchResults />
               </ErrorBoundary>
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
}

export default App;
